import { isActif, isAdministrateur, isAxianGroup, isEditor } from "../../request/Request";
import Login from "../Login";
import Unauthorized from './Unauthorized'

export default function PrivateEditor({ children }) {
    if (!isActif()) {
        return <Login />
    }
    if (isEditor() || isAdministrateur()) {
        return children;
    }
    return <Unauthorized />;
}

export function PrivateEditorGroup({ children }) {
    if (!isActif()) {
        return <Login />
    }
    if ((isAdministrateur() || isEditor()) && isAxianGroup()) {
        return children;
    }
    return <Unauthorized />;
}

export function PrivateAdministrateur({ children }) {
    if (!isActif()) {
        return <Login />
    }
    if (isAdministrateur()) {
        return children;
    }
    return <Unauthorized />;
}

export function PrivateGroup({ children }) {
    if (!isActif()) {
        return <Login />
    }
    if (isAxianGroup() || isAdministrateur()) {
        return children;
    }
    return <Unauthorized />
}

export function PrivateActif({ children }) {
    if (!isActif()) {
        return <Login />
    }
    return children;
}